import React from "react";
import { Tag, Popover, Button, List } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import DataTable from "../../../components/DataTable";

const formatDate = (dateString) => {
  if (!dateString) return "";
  return new Date(dateString).toLocaleDateString();
};

export default function JeyedaProjectsTable({
  data,
  loading,
  page,
  pageSize,
  onPageChange,
}) {
  const columns = [
    {
      title: "Project",
      dataIndex: "label",
      key: "label",
      width: "25%",
      sorter: (a, b) => (a.label || "").localeCompare(b.label || ""),
    },
    {
      title: "Datasource ID",
      key: "datasourceId",
      width: "20%",
      render: (_, record) => (record.dataSource ? record.dataSource.id : "N/A"),
      sorter: (a, b) => {
        const valA = a.dataSource ? a.dataSource.id.toString() : "";
        const valB = b.dataSource ? b.dataSource.id.toString() : "";
        return valA.localeCompare(valB);
      },
    },
    {
      title: "Owner & Collaborators",
      key: "owners",
      width: "30%",
      render: (_, record) => {
        const collaborators = Array.isArray(record.collaborators)
          ? record.collaborators
          : [];
        const content = (
          <div style={{ minWidth: 200 }}>
            <div
              style={{
                fontWeight: "bold",
                color: "#0D2E4D",
                marginBottom: "8px",
                borderBottom: "2px solid #0D2E4D",
                paddingBottom: "8px",
              }}
            >
              Collaborators
            </div>
            <List
              size="small"
              dataSource={collaborators}
              renderItem={(c) => <List.Item>{c?.username || "-"}</List.Item>}
              split={false}
            />
          </div>
        );
        return (
          <div style={{ display: "flex", alignItems: "center" }}>
            <Tag
              color="#0D2E4D"
              style={{ borderRadius: "12px", border: "none" }}
            >
              {record.owner?.username || "N/A"}
            </Tag>
            {collaborators.length > 0 && (
              <Popover content={content} trigger="click" placement="bottom">
                <Button
                  type="text"
                  icon={<PlusOutlined />}
                  shape="circle"
                  size="small"
                  style={{ color: "#D97A07", marginLeft: "4px" }}
                />
              </Popover>
            )}
          </div>
        );
      },
    },
    {
      title: "Created Date",
      dataIndex: "createdAt",
      key: "createdAt",
      width: "25%",
      render: (val) => formatDate(val),
      sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
    },
  ];

  return (
    <DataTable
      rowKey="id"
      columns={columns}
      data={data}
      loading={loading}
      page={page}
      pageSize={pageSize}
      onPageChange={onPageChange}
    />
  );
}
